import { render, staticRenderFns } from "./techprocessesTable.vue?vue&type=template&id=a8af1734&scoped=true"
import script from "./techprocessesTable.vue?vue&type=script&lang=js"
export * from "./techprocessesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8af1734",
  null
  
)

export default component.exports